import React, { FC, useRef, useEffect } from 'react';

import { ScoreType } from '../../store/admin/eventFormats/store';
import { IGroupEnrollment } from '../../store/player/games/store';
import { IScore } from '../../store/player/scores/store';

import {
  RoundScoreSummaryProvider,
  useRoundScoreSummaryDispatch
} from './Context/RoundScoreSummary.context';
import RoundScoreSummaryMainTable from './Components/RoundScoreSummaryMainTable/RoundScoreSummaryMainTable';
import RoundScoreSummaryPlayerDescription from './Components/RoundScoreSummaryPlayerDescription';
import RoundScoreSummaryHeader from './Components/RoundScoreSummaryHeader';

interface IProps {
  editing?: boolean;
  footer?: any;
  playerIndex?: number;
  formatIsStableford?: boolean;
  fullTable?: boolean;
  hideHandicapsRow?: boolean;
  hideHeader?: boolean;
  hideIndexRow?: boolean;
  hideNet?: boolean;
  showPlayerDescription?: boolean;
  item: IGroupEnrollment;
  onChange?: (newScores: number[]) => void;
  onChangePenalties?: (newPenalties: number) => void;
  onChangeSignature?: (isSigned: boolean) => void;
  onClose?: any;
  penalties?: number;
  playerScores?: IScore;
  range?: { start: number; length: number };
  scorer?: string;
  scoreType?: ScoreType;
  showWarning?: boolean;
  signed?: boolean;
  hideConfirmedSignature?: boolean;
  hideAddPenalties?: boolean;
}

const RoundScoreSummaryComponent = (props: IProps) => {
  const {
    editing,
    footer,
    playerIndex,
    formatIsStableford,
    fullTable = true,
    hideHandicapsRow,
    hideHeader,
    hideNet = false,
    hideIndexRow,
    showPlayerDescription = false,
    item,
    onChange,
    onChangePenalties,
    onChangeSignature,
    onClose,
    penalties,
    playerScores,
    range = { start: 0, length: 18 },
    scorer,
    scoreType,
    showWarning = false,
    hideAddPenalties = false,
    signed,
    hideConfirmedSignature = false
  } = props;

  const {
    actions: { processScores }
  } = useRoundScoreSummaryDispatch();

  useEffect(() => {
    if (playerScores) {
      processScores({ scores: playerScores.scores, scoreType, penalties });
    }
  }, [playerScores]);

  const formRef = useRef();

  const onReset = () => formRef && (formRef as any).current.resetForm();

  return (
    <div className="scorer-paper round-score-summary">
      {!hideHeader && <RoundScoreSummaryHeader onClose={onClose} showWarning={showWarning} />}

      {showPlayerDescription && <RoundScoreSummaryPlayerDescription item={item} />}

      <RoundScoreSummaryMainTable
        editing={editing}
        playerIndex={playerIndex}
        formatIsStableford={formatIsStableford}
        fullTable={fullTable}
        hideHandicapsRow={hideHandicapsRow}
        hideIndexRow={hideIndexRow}
        onChange={onChange}
        onChangePenalties={onChangePenalties}
        onChangeSignature={onChangeSignature}
        penalties={penalties}
        playerScores={playerScores}
        range={range}
        scorer={scorer}
        scoreType={scoreType}
        signed={signed}
        formRef={formRef}
        hideConfirmedSignature={hideConfirmedSignature}
        hideNet={hideNet}
        hideAddPenalties={hideAddPenalties}
      />

      {showWarning && <div className="warning padding">Missing Scores</div>}

      {footer && footer(onReset)}
    </div>
  );
};

const RoundScoreSummary: FC<IProps> = props => {
  return (
    <RoundScoreSummaryProvider>
      <RoundScoreSummaryComponent {...props} />
    </RoundScoreSummaryProvider>
  );
};

export default RoundScoreSummary;
